import type { ReactNode } from "react";

import type { Meta } from "@busright/data-contract";

import { FreshnessPill } from "./FreshnessPill";

export interface PageHeaderProps {
  readonly title: string;
  readonly description?: string;
  readonly meta?: Meta;
}

// Surface header: title + one-line description + a freshness pill driven by the endpoint's meta.
export const PageHeader = ({ title, description, meta }: PageHeaderProps): ReactNode => (
  <header className="page-header">
    <div>
      <h1>{title}</h1>
      {description ? <p>{description}</p> : null}
    </div>
    <div className="page-header-meta">
      <FreshnessPill meta={meta} />
    </div>
  </header>
);
